import { render } from "./AccommodationInfo.vue?vue&type=template&id=4f77374a&scoped=true"
import script from "./AccommodationInfo.vue?vue&type=script&lang=js"
export * from "./AccommodationInfo.vue?vue&type=script&lang=js"

import "./AccommodationInfo.vue?vue&type=style&index=0&id=4f77374a&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f77374a"]])

export default __exports__